export const formatDate = (date: string | Date) => {
  const d = new Date(date);
  return d.toLocaleDateString();
};

export const getYearStart = () => {
  const today = new Date();
  return new Date(today.getFullYear(), 0, 1).toISOString().split("T")[0];
};

export const getToday = () => {
  return new Date().toISOString().split("T")[0];
};

export const toLocalDateInputValue = (date: Date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getYearToDateRange = () => {
  const today = new Date();

  return {
    startDate: toLocalDateInputValue(new Date(today.getFullYear(), 0, 1)),
    endDate: toLocalDateInputValue(today),
  };
};
